export default "__VITE_ASSET__DA8yOGCX__"